class ProductReviews extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    if (!globalThis.jdgmCacheServer) {
      /* eslint-disable no-console */
      console.error('Judge.me cache server not found');
      return;
    }

    this.judgemeThemeEditorListener();
  }

  /**
   * Reloads the JudgeMe reviews when the section is reloaded in the theme editor
   */
  judgemeThemeEditorListener() {
    /* This event is triggered by the shopify theme editor.
    See https://shopify.dev/docs/storefronts/themes/architecture/sections/integrate-sections-with-the-theme-editor#javascript-events 
    */
    document.addEventListener('shopify:section:load', () => {
      globalThis.jdgmCacheServer.reloadAll();
    });
  }

  /**
   * Reloads the reviews widget
   * @param {String} productId
   * @returns {void}
   */
  static loadReviewsForProduct() {
    globalThis.jdgmCacheServer.reloadAll();
  }
}

// Define the custom element
customElements.get('product-reviews') ||
  customElements.define('product-reviews', ProductReviews);
export default ProductReviews;
